import Vue from "vue";
import { withTenant, noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.CORE_API_URL + "/convenio-medico";
const apiCardUrl = env.CORE_API_URL + "/carteirinha-paciente";
const apiMineCardUrl = apiCardUrl + "/minhas-carteirinhas";
const apiUrlClinic = env.CLINIC_API_URL + "/convenio-medico-profissional";

class MedicalInsuranceService {
  findAll() {
    return Vue.prototype.$axios.get(apiUrl, {
      headers: noTenant()
    });
  }

  findByProfessional(tenant, professional) {
    return Vue.prototype.$axios.get(apiUrlClinic, {
      params: {
        profissional: professional
      },
      headers: withTenant(tenant)
    });
  }

  findAllByTenant(tenant) {
    return Vue.prototype.$axios.get(apiUrlClinic, {
      headers: withTenant(tenant)
    });
  }

  urlUpload() {
    return apiCardUrl + "/upload";
  }

  findAllCards() {
    return this.findCardsByMedicalInsurance(null);
  }

  findCardsByMedicalInsurance(convenioMedico, tenant) {
    return Vue.prototype.$axios.get(apiMineCardUrl, {
      params: {
        convenioMedico
      },
      headers: tenant ? withTenant(tenant) : noTenant()
    });
  }

  saveCard(payload, tenant) {
    return Vue.prototype.$axios.post(apiCardUrl, payload, {
      headers: tenant ? withTenant(tenant) : noTenant()
    });
  }
}

export default new MedicalInsuranceService();
